angular.module('clientDashboardApp').directive('providerListingLink', () => {
  return {
    restrict: 'E',
    scope: {
      ngModel: '='
    },
    template: `
      <div class="full-width rel-parent">
        <div style="display: inline-block">
          <react-component name="BasicProviderImage" props="{provider:ngModel.contentProvider,style: { marginRight: '5px'}}"></react-component>
            <span style="font-weight: 600; vertical-align: middle;">
              {{providerName()}}
            </span>
          <br class="clearfix"/>
        </div>
        <br class="clearfix"/>
        <a 
            ng-show="shouldLink()"
            class="abs-link" ng-href="{{ngModel.listingURL}}" target="_blank"></a>
      </div>
`,
    controller: ($scope, providerService) => {
      $scope.providerName = () => {
        return providerService.displayNameFor($scope.ngModel.contentProvider)
      }
      $scope.shouldLink = () => {
        var provider = providerService.getProvider($scope.ngModel.contentProvider);
        var displaySettings = provider ? provider.displaySettings : {};
        return displaySettings.displaysListingUrl
          && $scope.ngModel && $scope.ngModel.listingURL && $scope.ngModel.listingURL.length
      }
    }
  }
})
